<template>
  <div style="margin-top: 10px">
    <div
      class="chart_row_two text-white pb-6"
      style="margin-top: 30px; margin-bottom: 100px !important"
    >
      <!-- 1st chart -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartData"
            :donutchartOptions="chartOptions"
            chartWidth="200px"
            chartHeight="200px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 40px">412</p>
            <p
              class="p-0 m-0 text-center"
              style="font-weight: 600; margin-top: -13px !important"
            >
              Total Tasks
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div class="w-50" style="border-right: 1px solid #80808071">
            <p
              class="text-center p-0 m-0"
              style="font-size: 30px; font-family: 600"
            >
              00
            </p>
            <p
              class="text-center"
              style="
                color: greenyellow !important;
                font-weight: 600;
                margin-top: -10px !important;
              "
            >
              Active Tasks
            </p>
          </div>

          <div class="w-50">
            <p
              class="text-center p-0 m-0"
              style="font-size: 30px; font-family: 600"
            >
              139
            </p>
            <p
              class="text-center"
              style="
                color: yellow !important;
                font-weight: 600;
                margin-top: -10px !important;
              "
            >
              Pending Tasks
            </p>
          </div>
        </div>
      </div>
      <!-- middle chart -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div>
          <p class="text-center p-0 m-0" style="font-size: 50px">
            23.6
            <span class="p-0 m-0" style="font-size: 30px">ms</span>
          </p>
          <p
            class="text-center"
            style="
              color: yellow;
              font-weight: 500;
              margin-top: -10px !important;
            "
          >
            Task Wait Time
          </p>

          <div class="d-flex justify-content-center">
            <button class="statBtn">32%</button>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
        >
          <GradientGraphChart
            id="chart-line4"
            title="Chart"
            :chart="chartData"
          />
        </div>
      </div>

      <!-- third chart -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div>
          <p class="text-center p-0 m-0" style="font-size: 50px">12%</p>
          <p
            class="text-center"
            style="color: red; font-weight: 600; margin-top: -10px !important"
          >
            Task Failure Rate
          </p>

          <div class="d-flex justify-content-center">
            <button class="statBtn bg-danger">17%</button>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
        >
          <GradientGraphChart
            id="chart-line5"
            title="Chart"
            :chart="chartData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonutChart from "@/examples/Charts/DonutChart.vue";
import GradientGraphChart from "@/examples/Charts/GradientGraphChart.vue";

export default {
  name: "TasksTab",
  components: {
    DonutChart,
    GradientGraphChart,
  },
  props: {
    donutchartData: {
      type: Object,
      default: () => ({
        datasets: [
          {
            label: "My Dataset",
            data: [0, 0, 100],
            backgroundColor: ["#adff2f", "#ffff00"],
            hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
          },
        ],
      }),
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
      }),
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
};
</script>

